export default function inThePressMapper(componentsData) {
  const { titleSection, ...rest } = componentsData;

  return {
    title: titleSection,
    ...rest,
  };
}
